export default __webpack_public_path__ + "static/media/cwc.8fa07fe2.svg";